import React from "react";
import NavBar from "../components/Navbar/NavBar";
import Footer from "../components/Footer";
import { useDocTitle } from "../components/CustomHook";

const Terms = () => {
  useDocTitle("ZelT | Terms of Service");

  return (
    <div>
      <NavBar />
      <div className="mt-8 w-full bg-white py-12 lg:py-20">
        <div className="mx-4 max-w-3xl mx-auto">
          <h1 className="text-4xl font-extrabold text-blue-900 text-center mb-10">
            Terms of Service
          </h1>
          <div className="space-y-8 text-gray-600 leading-relaxed">
            <p className="text-sm text-gray-400">Last updated: September 2026</p>

            <section>
              <h2 className="text-xl font-bold text-blue-900 mb-2">1. Acceptance</h2>
              <p>
                By using zeltechnology.org and becoming a member, you agree to
                these terms. If you do not agree, please do not use the
                service.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-blue-900 mb-2">
                2. What ZelTechnology Provides
              </h2>
              <p>
                ZelTechnology is a nonprofit organization providing free
                technology guidance, educational resources, community tools,
                and AI-based services to its members. Services are provided
                "as is" with goodwill and best effort.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-blue-900 mb-2">
                3. No Professional Warranty
              </h2>
              <p>
                Guidance provided by ZelTechnology — human or AI-assisted — is
                general technology assistance, not a professional warranty.
                Always back up important data before making changes to your
                devices. You are responsible for your own data and decisions.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-blue-900 mb-2">
                4. Member Conduct
              </h2>
              <p>Members agree to:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Use the service lawfully and respectfully.</li>
                <li>Not attempt to harm, overload, or gain unauthorized access to our systems.</li>
                <li>Not use ZelTechnology services for spam, fraud, or harassment.</li>
                <li>Provide accurate registration information.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-bold text-blue-900 mb-2">
                5. Accounts
              </h2>
              <p>
                You are responsible for keeping your password confidential. We
                may suspend accounts used in violation of these terms.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-blue-900 mb-2">
                6. Remote Support Sessions
              </h2>
              <p>
                Members may request supervised remote support ("Virtual House
                Call"). By participating in a remote session, you understand
                and agree that:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>
                  Sessions are initiated <b>only at your request</b> and
                  require your explicit on-screen approval to begin.
                </li>
                <li>
                  You are responsible for backing up important data{" "}
                  <b>before</b> the session. ZelTechnology is not liable for
                  pre-existing problems, hardware failures, or data loss.
                </li>
                <li>
                  You may end any session at any time with the on-screen End
                  Session control, and technicians must stop immediately when
                  asked.
                </li>
                <li>
                  ZelTechnology does not provide unattended or persistent
                  access, does not store session recordings, and technicians
                  are prohibited from accessing accounts or files beyond the
                  agreed scope.
                </li>
                <li>
                  Sessions may be logged (date, technician, duration, general
                  summary) for accountability; screen contents are never
                  recorded or stored.
                </li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-bold text-blue-900 mb-2">
                7. Limitation of Liability
              </h2>
              <p>
                To the fullest extent permitted by law, ZelTechnology shall
                not be liable for indirect, incidental, or consequential
                damages arising from use of the service, including data loss.
                Our total liability for any claim shall not exceed zero
                dollars, as the service is provided free of charge.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-blue-900 mb-2">
                8. Changes
              </h2>
              <p>
                We may update these terms occasionally. Material changes will
                be announced on the site. Continued use after changes
                constitutes acceptance.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-blue-900 mb-2">9. Contact</h2>
              <p>
                Questions about these terms: ZelTechnology — #1055, 11160
                Rancho Carmel Dr STE 106, San Diego, CA 92128 —{" "}
                support@zeltechnology.org
              </p>
            </section>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Terms;
